var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 25,
    viewBox: "0 0 50 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C3.68136e-07 20.789 1.06368 16.6463 3.09233 12.9562C5.12099 9.26604 8.04889 6.14815 11.6043 3.8918L25 25L0 25Z",
    fill: "url(#paint0_linear_341_36)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1595 2.98179C16.8682 0.987381 21.0206 -0.0379059 25.2314 0.00107094C29.4422 0.0400478 33.5749 1.14203 37.2461 3.20475L25 25L13.1595 2.98179Z",
    fill: "url(#paint1_linear_341_36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5564 3.99466C42.0945 6.27809 44.9985 9.41824 46.999 13.1237C48.9994 16.8292 50.0314 20.98 49.9993 25.1908L25 25L38.5564 3.99466Z",
    fill: "url(#paint2_linear_341_36)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_36",
    x1: -2.37226,
    y1: 20.2555,
    x2: 57.1168,
    y2: 19.5255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331417,
    stopColor: "#FFED4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578505,
    stopColor: "#FF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_341_36",
    x1: -2.37226,
    y1: 20.2555,
    x2: 57.1168,
    y2: 19.5255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331417,
    stopColor: "#FFED4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578505,
    stopColor: "#FF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_341_36",
    x1: -2.37226,
    y1: 20.2555,
    x2: 57.1168,
    y2: 19.5255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331417,
    stopColor: "#FFED4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578505,
    stopColor: "#FF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBg);
export default __webpack_public_path__ + "static/media/clock-bg.1e6e8e0f91aac52ddaf7530b2c0fb51d.svg";
export { ForwardRef as ReactComponent };